import React, { useState, useEffect } from "react";
import { FaEye, FaPaperPlane, FaBookmark, FaChevronLeft, FaChevronRight, FaHeart, FaRegHeart } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import starIcon from './star.png';
import moneyIcon from './money.png';
import locationIcon from './location.png';
import ahmedImage from './ahmed.png';
import A1 from './A1.png';
import A2 from './A2.png';
import A3 from './A3.png';
import Circle from './Circle';
import teacherMan1 from './teacher_man1.png';
import teacherFemale1 from './teacher_female1.webp';
import teacherFemale2 from './teacher_female2.jpg';
import './App.css';
import { supabase } from './supabaseClient';
import TeacherRatingDisplay from './components/TeacherRatingDisplay';
import { getMultipleTeacherRatings } from './bookingService';
import { toggleFavoriteTeacher } from './favoriteService';

// Compact TeacherCard for homepage - fits 4 in a row
function TeacherCard({ teacher, lang, rating, isFavorited, onToggleFavorite, isMobile = false }) {
  const formatArabicList = (items) => {
    if (!Array.isArray(items) || items.length === 0) return '';
    if (items.length === 1) return items[0];
    if (items.length === 2) return `${items[0]} و${items[1]}`;
    return items.slice(0, 2).join('، ') + '...';
  };

  return (
    <div
      className="teacher-card-hover"
      style={{
        background: 'linear-gradient(145deg, #ffffff 0%, #fefefe 100%)',
        borderRadius: 20,
        boxShadow: '0 4px 24px rgba(30, 41, 59, 0.08)',
        padding: '24px 20px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        position: 'relative',
        transition: 'all 0.3s ease',
        border: '1px solid rgba(255, 116, 38, 0.1)',
        direction: lang === 'ar' ? 'rtl' : 'ltr',
        textAlign: 'center',
      }}
    >
      {/* Favorite Button - Only show if onToggleFavorite is provided */}
      {onToggleFavorite && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onToggleFavorite(teacher.uuid_id || teacher.id);
          }}
          style={{
            position: 'absolute',
            top: 12,
            right: lang === 'ar' ? 'auto' : 12,
            left: lang === 'ar' ? 12 : 'auto',
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            fontSize: 20,
            color: isFavorited ? '#FF7426' : '#CBD5E1',
            transition: 'all 0.2s ease',
            padding: 8,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'scale(1.2)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
          }}
          title={isFavorited ? (lang === 'ar' ? 'إزالة من المفضلة' : 'Remove from favorites') : (lang === 'ar' ? 'إضافة للمفضلة' : 'Add to favorites')}
        >
          {isFavorited ? <FaHeart /> : <FaRegHeart />}
        </button>
      )}

      {/* Profile Photo with gradient ring */}
      <div style={{
        position: 'relative',
        marginBottom: 16
      }}>
        <div style={{
          width: 80,
          height: 80,
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #FF7426 0%, #FFA726 100%)',
          padding: 3,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <img 
            src={teacher.profile_photo || ahmedImage} 
            alt={teacher.full_name}
            style={{ 
              width: 74, 
              height: 74, 
              borderRadius: '50%', 
              objectFit: 'cover',
              border: '3px solid #fff'
            }} 
            loading="lazy" 
          />
        </div>
      </div>

      {/* Name */}
      <h3 style={{ 
        fontSize: 16, 
        fontWeight: 700, 
        margin: 0,
        marginBottom: 4,
        color: '#1E293B',
        fontFamily: "'IBM Plex Sans Arabic', sans-serif"
      }}>
        {teacher.full_name}
      </h3>

      {/* Subjects as tags */}
      <div style={{ 
        display: 'flex', 
        flexWrap: 'wrap', 
        gap: 6, 
        justifyContent: 'center',
        marginBottom: 12
      }}>
        {(teacher.subjects || []).slice(0, 2).map((subject, idx) => (
          <span key={idx} style={{
            background: 'linear-gradient(135deg, #FF7426 0%, #FFA726 100%)',
            color: '#fff',
            fontSize: 11,
            fontWeight: 600,
            padding: '4px 10px',
            borderRadius: 20,
            fontFamily: "'IBM Plex Sans Arabic', sans-serif"
          }}>
            {subject}
          </span>
        ))}
      </div>

      {/* Rating */}
      <TeacherRatingDisplay
        avgRating={rating?.avg_rating || 0}
        ratingsCount={rating?.ratings_count || 0}
        isArabic={lang === 'ar'}
        size="medium"
        showCount={false}
        style={{ marginBottom: 8 }}
      />

      {/* Price */}
      <div style={{
        background: '#F8FAFC',
                    borderRadius: 12, 
        padding: '8px 16px',
        marginBottom: 16,
        display: 'flex',
        alignItems: 'center',
        gap: 6
      }}>
        <span style={{ fontSize: 18, fontWeight: 700, color: '#1E293B' }}>
          {teacher.hourly_rate} BD
                </span>
        <span style={{ fontSize: 12, color: '#64748B' }}>
          {lang === 'ar' ? '/ ساعة' : '/ hour'}
              </span>
      </div>

      {/* Action Button */}
          <button
            style={{
          width: '100%',
          padding: '12px 20px',
          borderRadius: 12,
          background: 'linear-gradient(135deg, #1E293B 0%, #334155 100%)',
          color: '#fff',
          fontWeight: 600,
          fontSize: 13,
          border: 'none',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 8,
          transition: 'all 0.3s ease',
          boxShadow: '0 4px 12px rgba(30, 41, 59, 0.2)',
          fontFamily: "'IBM Plex Sans Arabic', sans-serif"
            }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = 'linear-gradient(135deg, #FF7426 0%, #FFA726 100%)';
          e.currentTarget.style.transform = 'translateY(-2px)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = 'linear-gradient(135deg, #1E293B 0%, #334155 100%)';
          e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
        <FaEye size={14} />
        {lang === 'ar' ? 'عرض الملف' : 'View Profile'}
          </button>
    </div>
  );
}

// English teachers array
const teachersEn = [
  {
    full_name: 'abdulla hilal',
    languages: ['Arabic', 'English', 'Russian'],
    subjects: ['Math', 'Science', 'Biology'],
    grade_levels: ['Grade 1', 'Grade 2', 'Grade 3'],
    bio: 'Math teacher with 6 years of experience in Bahrain. Excited to be part of this great platform!',
    hourly_rate: '4',
    profile_photo: ahmedImage,
    places: ['Your Home', 'Public Places'],
  },
  {
    full_name: 'Fatima Yusuf',
    languages: ['Arabic', 'English'],
    subjects: ['English', 'History'],
    grade_levels: ['Grade 4', 'Grade 5'],
    bio: 'Experienced English and History teacher passionate about student growth.',
    hourly_rate: '5',
    profile_photo: teacherFemale1,
    places: ['Public Places'],
  },
  {
    full_name: 'Mohamed Ali',
    languages: ['Arabic'],
    subjects: ['Physics', 'Math'],
    grade_levels: ['Grade 10', 'Grade 11'],
    bio: 'Physics and Math teacher with 10 years of experience.',
    hourly_rate: '6',
    profile_photo: teacherMan1,
    places: ['Your Home'],
  },
  {
    full_name: 'Sara Ahmed',
    languages: ['English', 'French'],
    subjects: ['French', 'Science'],
    grade_levels: ['Grade 7', 'Grade 8'],
    bio: 'Science and French teacher who loves interactive learning.',
    hourly_rate: '7',
    profile_photo: teacherFemale2,
    places: ['Public Places', 'Your Home'],
  },
];

// Arabic teachers array
const teachersAr = [
  {
    full_name: 'abdulla hilal',
    languages: ['العربية', 'الإنجليزية', 'الروسية'],
    subjects: ['الرياضيات', 'العلوم', 'الأحياء'],
    grade_levels: ['الصف الأول', 'الصف الثاني', 'الصف الثالث'],
    bio: 'معلم رياضيات بخبرة 6 سنوات في البحرين. متحمس لأن أكون جزءًا من هذه المنصة الرائعة!',
    hourly_rate: '4',
    profile_photo: ahmedImage,
    places: ['منزلك', 'أماكن عامة'],
  },
  {
    full_name: 'Fatima Yusuf',
    languages: ['الإنجليزية', 'الفرنسية'],
    subjects: ['العلوم', 'الرياضيات', 'العربية'],
    grade_levels: ['الصف الأول', 'الصف السابع', 'الصف التاسع'],
    bio: 'معلمة إنجليزي وتاريخ ذات خبرة وشغف بنمو الطلاب.',
    hourly_rate: '5',
    profile_photo: teacherFemale1,
    places: ['أماكن عامة'],
  },
  {
    full_name: 'Mohamed Ali',
    languages: ['العربية', 'الإنجليزية'],
    subjects: ['الرياضيات'],
    grade_levels: ['الصف الأول', 'الصف الثاني'],
    bio: 'معلم فيزياء ورياضيات بخبرة 10 سنوات.',
    hourly_rate: '6',
    profile_photo: teacherMan1,
    places: ['منزل الطالب', 'منزل المعلم', 'الأماكن العامة'],
  },
  {
    full_name: 'Sara Ahmed',
    languages: ['الإنجليزية', 'الفرنسية'],
    subjects: ['الفرنسية', 'العلوم'],
    grade_levels: ['الصف السابع', 'الصف الثامن'],
    bio: 'معلمة علوم وفرنسي تحب التعلم التفاعلي.',
    hourly_rate: '7',
    profile_photo: teacherFemale2,
    places: ['أماكن عامة', 'منزلك'],
  },
];

export default function OurTeachersSection({ lang }) {
  const [isMobile, setIsMobile] = useState(false);
  const [currentIdx, setCurrentIdx] = useState(0);
  const navigate = useNavigate();
  const [teachers, setTeachers] = useState([]);
  const [teacherRatings, setTeacherRatings] = useState({});
  const [loading, setLoading] = useState(true);
  const [favoriteTeachers, setFavoriteTeachers] = useState([]);

  // Fetch favorite teachers
  useEffect(() => {
    async function fetchFavorites() {
      const { getFavoriteTeachers } = await import('./favoriteService');
      const { data } = await getFavoriteTeachers();
      setFavoriteTeachers(data || []);
    }
    fetchFavorites();
  }, []);

  // Fetch teachers from Supabase
  useEffect(() => {
    async function fetchTeachers() {
      try {
        setLoading(true);
        const { data, error } = await supabase
          .from('Teachers')
          .select('*')
          .limit(8); // Show top 8 teachers on homepage

        if (error) throw error;

        if (data) {
          // Filter complete profiles
          const completeTeachers = data.filter(teacher => (
            teacher.full_name &&
            teacher.email &&
            Array.isArray(teacher.subjects) && teacher.subjects.length > 0 &&
            Array.isArray(teacher.grade_levels) && teacher.grade_levels.length > 0 &&
            teacher.profile_photo && teacher.profile_photo.trim() !== ''
          ));

          // Add fake teachers for now
          const fakeTeacher1 = {
            full_name: lang === 'ar' ? 'أحمد الخالدي' : 'Ahmed Al-Khaldi',
            email: 'fake-teacher-1@taealam.com',
            profile_photo: 'https://i.pravatar.cc/150?img=12',
            subjects: lang === 'ar' ? ['الرياضيات', 'الفيزياء'] : ['Mathematics', 'Physics'],
            grade_levels: lang === 'ar' ? ['الصف العاشر', 'الصف الحادي عشر'] : ['Grade 10', 'Grade 11'],
            hourly_rate: '8',
            teacher_uuid: 'fake-teacher-001',
            uuid_id: 'fake-teacher-001',
            created_at: new Date().toISOString()
          };
          
          const fakeTeacher2 = {
            full_name: lang === 'ar' ? 'سارة محمد' : 'Sara Mohamed',
            email: 'fake-teacher-2@taealam.com',
            profile_photo: 'https://i.pravatar.cc/150?img=47',
            subjects: lang === 'ar' ? ['اللغة الإنجليزية', 'الأدب'] : ['English', 'Literature'],
            grade_levels: lang === 'ar' ? ['الصف السابع', 'الصف الثامن'] : ['Grade 7', 'Grade 8'],
            hourly_rate: '7',
            teacher_uuid: 'fake-teacher-002',
            uuid_id: 'fake-teacher-002',
            created_at: new Date().toISOString()
          };
          
          const fakeTeacher3 = {
            full_name: lang === 'ar' ? 'محمد العلي' : 'Mohammed Al-Ali',
            email: 'fake-teacher-3@taealam.com',
            profile_photo: 'https://i.pravatar.cc/150?img=33',
            subjects: lang === 'ar' ? ['الكيمياء', 'الأحياء'] : ['Chemistry', 'Biology'],
            grade_levels: lang === 'ar' ? ['الصف التاسع', 'الصف العاشر'] : ['Grade 9', 'Grade 10'],
            hourly_rate: '9',
            teacher_uuid: 'fake-teacher-003',
            uuid_id: 'fake-teacher-003',
            created_at: new Date().toISOString()
          };
          
          const fakeTeacher4 = {
            full_name: lang === 'ar' ? 'فاطمة حسن' : 'Fatima Hassan',
            email: 'fake-teacher-4@taealam.com',
            profile_photo: 'https://i.pravatar.cc/150?img=68',
            subjects: lang === 'ar' ? ['اللغة العربية', 'التاريخ'] : ['Arabic', 'History'],
            grade_levels: lang === 'ar' ? ['الصف الخامس', 'الصف السادس'] : ['Grade 5', 'Grade 6'],
            hourly_rate: '6',
            teacher_uuid: 'fake-teacher-004',
            uuid_id: 'fake-teacher-004',
            created_at: new Date().toISOString()
          };

          // Combine real and fake teachers, limit to 4 total
          const allTeachers = [...completeTeachers, fakeTeacher1, fakeTeacher2, fakeTeacher3, fakeTeacher4];

          // Fetch ratings
          const teacherEmails = allTeachers.map(t => t.email);
          const { data: ratingsData } = await getMultipleTeacherRatings(teacherEmails);

          // Sort teachers: favorited first, then by rating
          const sortedTeachers = allTeachers.sort((a, b) => {
            const aIsFavorited = favoriteTeachers.includes(a.teacher_uuid || a.uuid_id);
            const bIsFavorited = favoriteTeachers.includes(b.teacher_uuid || b.uuid_id);

            if (aIsFavorited && !bIsFavorited) return -1;
            if (!aIsFavorited && bIsFavorited) return 1;
            return 0; // Keep original order if both favorited or both not favorited
          });

          // Limit to 4 teachers total (mix of real and fake)
          const limitedTeachers = sortedTeachers.slice(0, 4);

          setTeachers(limitedTeachers);
          setTeacherRatings(ratingsData || {});
        }
      } catch (err) {
        console.error('Error fetching teachers:', err);
        // Add fake teachers even if fetch fails
        const fakeTeacher1 = {
          full_name: lang === 'ar' ? 'أحمد الخالدي' : 'Ahmed Al-Khaldi',
          email: 'fake-teacher-1@taealam.com',
          profile_photo: 'https://i.pravatar.cc/150?img=12',
          subjects: lang === 'ar' ? ['الرياضيات', 'الفيزياء'] : ['Mathematics', 'Physics'],
          grade_levels: lang === 'ar' ? ['الصف العاشر', 'الصف الحادي عشر'] : ['Grade 10', 'Grade 11'],
          hourly_rate: '8',
          teacher_uuid: 'fake-teacher-001',
          uuid_id: 'fake-teacher-001',
          created_at: new Date().toISOString()
        };
        
        const fakeTeacher2 = {
          full_name: lang === 'ar' ? 'سارة محمد' : 'Sara Mohamed',
          email: 'fake-teacher-2@taealam.com',
          profile_photo: 'https://i.pravatar.cc/150?img=47',
          subjects: lang === 'ar' ? ['اللغة الإنجليزية', 'الأدب'] : ['English', 'Literature'],
          grade_levels: lang === 'ar' ? ['الصف السابع', 'الصف الثامن'] : ['Grade 7', 'Grade 8'],
          hourly_rate: '7',
          teacher_uuid: 'fake-teacher-002',
          uuid_id: 'fake-teacher-002',
          created_at: new Date().toISOString()
        };
        
        const fakeTeacher3 = {
          full_name: lang === 'ar' ? 'محمد العلي' : 'Mohammed Al-Ali',
          email: 'fake-teacher-3@taealam.com',
          profile_photo: 'https://i.pravatar.cc/150?img=33',
          subjects: lang === 'ar' ? ['الكيمياء', 'الأحياء'] : ['Chemistry', 'Biology'],
          grade_levels: lang === 'ar' ? ['الصف التاسع', 'الصف العاشر'] : ['Grade 9', 'Grade 10'],
          hourly_rate: '9',
          teacher_uuid: 'fake-teacher-003',
          uuid_id: 'fake-teacher-003',
          created_at: new Date().toISOString()
        };
        
        const fakeTeacher4 = {
          full_name: lang === 'ar' ? 'فاطمة حسن' : 'Fatima Hassan',
          email: 'fake-teacher-4@taealam.com',
          profile_photo: 'https://i.pravatar.cc/150?img=68',
          subjects: lang === 'ar' ? ['اللغة العربية', 'التاريخ'] : ['Arabic', 'History'],
          grade_levels: lang === 'ar' ? ['الصف الخامس', 'الصف السادس'] : ['Grade 5', 'Grade 6'],
          hourly_rate: '6',
          teacher_uuid: 'fake-teacher-004',
          uuid_id: 'fake-teacher-004',
          created_at: new Date().toISOString()
        };
        
        // Fallback to mock data if Supabase fails
        const mockTeachers = lang === 'ar' ? teachersAr : teachersEn;
        const allMockTeachers = [...mockTeachers, fakeTeacher1, fakeTeacher2, fakeTeacher3, fakeTeacher4];
        // Limit to 4 teachers total
        const limitedMockTeachers = allMockTeachers.slice(0, 4);
        setTeachers(limitedMockTeachers);
        setTeacherRatings({});
      } finally {
        setLoading(false);
      }
    }

    fetchTeachers();
  }, [lang, favoriteTeachers]); // Re-fetch when language or favorites change

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 700);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handlePrev = () => setCurrentIdx(idx => Math.max(idx - 1, 0));
  const handleNext = () => setCurrentIdx(idx => Math.min(idx + 1, teachers.length - 1));

  // Handle favorite toggle
  const handleToggleFavorite = async (teacherUuid) => {
    const { success, isFavorited } = await toggleFavoriteTeacher(teacherUuid);
    if (success) {
      // Update local state to re-sort teachers
      if (isFavorited) {
        setFavoriteTeachers([...favoriteTeachers, teacherUuid]);
      } else {
        setFavoriteTeachers(favoriteTeachers.filter(id => id !== teacherUuid));
      }
    }
  };

  // Dynamic section title and description
  const sectionTitle = lang === 'ar' ? 'معلمونا' : 'Our Teachers';
  const sectionDesc = lang === 'ar' ? 'تعرّف على معلمينا المميزين وابدأ رحلتك التعليمية' : 'Meet our expert educators and start your learning journey';

  return (
    <div className="flex justify-center w-full" dir={lang === 'ar' ? 'rtl' : 'ltr'}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;700&display=swap');
        .font-cairo { font-family: 'Cairo', sans-serif !important; }
        .teacher-card-hover:hover {
          transform: translateY(-8px);
          box-shadow: 0 12px 40px rgba(255, 116, 38, 0.15);
          border-color: rgba(255, 116, 38, 0.3);
        }
        @media (min-width: 1200px) {
          .teachers-grid {
            grid-template-columns: repeat(4, 1fr) !important;
            gap: 24px !important;
          }
        }
        @media (min-width: 900px) and (max-width: 1199px) {
          .teachers-grid {
            grid-template-columns: repeat(3, 1fr) !important;
            gap: 20px !important;
          }
        }
        @media (min-width: 600px) and (max-width: 899px) {
          .teachers-grid {
            grid-template-columns: repeat(2, 1fr) !important;
            gap: 16px !important;
          }
        }
        @media (max-width: 599px) {
          .teachers-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
      <div className="w-full" dir={lang === 'ar' ? 'rtl' : 'ltr'}>
        {/* Box container matching "What You'll Get" style */}
        <div
          className="rounded-2xl md:rounded-3xl p-6 md:p-12 shadow-[0_4px_20px_rgba(0,0,0,0.06)] border border-white/70 w-full"
          style={{
            background: '#FFFFFF'
          }}
        >
          {/* Section Header */}
          <div style={{ textAlign: 'center', marginBottom: 40 }}>
            <h2 style={{ 
              fontSize: isMobile ? '1.5rem' : 'clamp(1.75rem, 3vw, 2.25rem)', 
              fontWeight: 700, 
              color: '#1E293B', 
              marginBottom: 12,
              fontFamily: "'IBM Plex Sans Arabic', sans-serif" 
            }}>
              {sectionTitle}
            </h2>
            <p style={{ 
              color: '#64748B', 
              fontSize: isMobile ? '0.95rem' : '1.1rem', 
              maxWidth: 500,
              margin: '0 auto',
              lineHeight: 1.6,
              fontFamily: "'IBM Plex Sans Arabic', sans-serif" 
            }}>
              {lang === 'ar' ? 'تعرّف على معلمينا المميزين وابدأ رحلتك التعليمية' : 'Meet our expert educators and start your learning journey'}
        </p>
          </div>

          {/* Loading State */}
          {loading ? (
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: 300,
              color: '#64748B',
              fontSize: 14,
              fontFamily: "'IBM Plex Sans Arabic', sans-serif"
            }}>
              {lang === 'ar' ? 'جاري التحميل...' : 'Loading teachers...'}
            </div>
          ) : (
            <>
          {/* Teachers Grid - Responsive layout */}
        {isMobile ? (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 16, width: '100%', maxWidth: 400 }}>
              <button onClick={handlePrev} disabled={currentIdx === 0} style={{ background: 'none', border: 'none', color: '#FF7426', fontSize: 28, cursor: currentIdx === 0 ? 'not-allowed' : 'pointer', opacity: currentIdx === 0 ? 0.3 : 1, flexShrink: 0 }}>
                {lang === 'ar' ? <FaChevronRight /> : <FaChevronLeft />}
              </button>
              <div style={{ flex: 1, maxWidth: 320 }}>
                {teachers.length > 0 && (
                  <TeacherCard
                    teacher={teachers[currentIdx]}
                    lang={lang}
                    rating={teacherRatings[teachers[currentIdx]?.email]}
                    isFavorited={favoriteTeachers.includes(teachers[currentIdx]?.teacher_uuid)}
                    onToggleFavorite={handleToggleFavorite}
                    isMobile={isMobile}
                  />
                )}
              </div>
              <button onClick={handleNext} disabled={currentIdx === teachers.length - 1} style={{ background: 'none', border: 'none', color: '#FF7426', fontSize: 28, cursor: currentIdx === teachers.length - 1 ? 'not-allowed' : 'pointer', opacity: currentIdx === teachers.length - 1 ? 0.3 : 1, flexShrink: 0 }}>
                {lang === 'ar' ? <FaChevronLeft /> : <FaChevronRight />}
              </button>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', gap: 6, marginTop: 8 }}>
              {teachers.map((_, i) => (
                  <span key={i} style={{ width: 12, height: 6, borderRadius: 3, background: i === currentIdx ? '#FF7426' : '#E2E8F0', display: 'inline-block', transition: 'background 0.2s' }} />
              ))}
            </div>
          </div>
        ) : (
            <div
              className="teachers-grid"
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(4, 1fr)',
                gap: 24,
                marginBottom: 32,
                maxWidth: '1400px',
                margin: '0 auto 32px auto'
              }}
            >
            {teachers.map((t, i) => (
              <TeacherCard
                key={i}
                teacher={t}
                lang={lang}
                rating={teacherRatings[t.email]}
                isFavorited={favoriteTeachers.includes(t.teacher_uuid)}
                onToggleFavorite={handleToggleFavorite}
                isMobile={isMobile}
              />
            ))}
          </div>
        )}
            </>
          )}

          {/* View More Button */}
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: 24 }}>
            <button 
              onClick={() => navigate('/signin')}
              style={{
                background: 'linear-gradient(135deg, #FF7426 0%, #FFA726 100%)',
                color: '#fff',
                border: 'none',
                padding: '14px 48px',
                fontSize: '1rem',
                fontWeight: 600,
                borderRadius: 50,
                cursor: 'pointer',
                boxShadow: '0 6px 24px rgba(255, 116, 38, 0.3)',
                transition: 'all 0.3s ease',
                fontFamily: "'IBM Plex Sans Arabic', sans-serif"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 8px 32px rgba(255, 116, 38, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 6px 24px rgba(255, 116, 38, 0.3)';
              }}
            >
              {lang === 'ar' ? 'عرض جميع المعلمين' : 'View All Teachers'}
          </button>
          </div>
        </div>
      </div>
    </div>
  );
} 